import React from 'react';
import './PeriodFilter.css';

export const PERIODS = [
  { key: '15', label: '15 days', days: 15 },
  { key: '30', label: '30 days', days: 30 },
  { key: '60', label: '60 days', days: 60 },
  { key: 'all', label: 'All time', days: null }
];

/** Keeps only tickets created within the period. `all` passes everything. */
export function withinPeriod(tickets, periodKey) {
  const period = PERIODS.find((p) => p.key === periodKey);
  if (!period || period.days === null) return tickets;
  const cutoff = Date.now() - period.days * 86400000;
  return tickets.filter((t) => {
    const created = t.created_at ? new Date(t.created_at).getTime() : NaN;
    // A ticket with no usable date is kept rather than silently dropped.
    return Number.isNaN(created) ? true : created >= cutoff;
  });
}

function PeriodFilter({ value, onChange, label = 'Period' }) {
  return (
    <div className="period-filter" role="group" aria-label={label}>
      {PERIODS.map((p) => (
        <button
          key={p.key}
          type="button"
          className={`period-option${value === p.key ? ' is-active' : ''}`}
          aria-pressed={value === p.key}
          onClick={() => onChange(p.key)}
        >
          {p.label}
        </button>
      ))}
    </div>
  );
}

export default PeriodFilter;
